import { createContext } from 'react'
import { DEFAULT_THEME, DEFAULT_CONFIG } from './constants'

export type Theme = {
  borderRadius: string
  colorLink: string
  colorLinkHover: string
  colorLinkActive: string
  controlHeight: string
  controlInteractiveSize: string
  labelColor: string
  colorPrimaryHover: string
  colorPrimary: string
  registerPolicyCheckbox: boolean
  showRegisterForm: boolean
  loginBGImage: string
  logoHeight: string
  logo: string
}

export type Config = {
  realm: string
  apiHost: string
  redirectUri: string | null
}

export type CustomisationContextType = {
  theme: Theme
  config: Config
  setTheme: (theme: Theme) => void
  setConfig: (config: Config) => void
  apiHost: string
  realm: string
  redirectUri: string | null
  loading: boolean
}

export const CustomisationContext = createContext<CustomisationContextType>({
  theme: DEFAULT_THEME,
  config: DEFAULT_CONFIG,
  setTheme: () => {},
  setConfig: () => {},
  apiHost: DEFAULT_CONFIG.apiHost,
  realm: DEFAULT_CONFIG.realm,
  redirectUri: null,
  loading: false,
})
